export const AUTH0_DOMAIN = 'dev-0jzuv6tnpwxxioe6.uk.auth0.com';
export const AUTH0_CLIENTID = 'mJLmvY2JTE0xsIVujH7BF6m7ZzK5H548';
export const AUTH0_REDIRECT_URI =
  'https://www.timeshighereducation.local/datapoints';
export const AUTH0_AUDIENCE =
  'https://api.timeshighereducation.local/datapoints/graphql';
export const AUTH0_SCOPE =
  'read:user read:current_user update:current_user_metadata read:my_submissions submit:my_submission openid';
